module.exports = __webpack_public_path__ + "img/gift-03-c2.5385bad9.png";